import OrchestratorAPI from './common';

import { JobValidation } from '../models/encounter';

interface FindAllOptions {
  jobId?: number;
}

export default class API extends OrchestratorAPI {
  protected readonly API_PATH = '/job-validations';

  async findAll(options: FindAllOptions = {}): Promise<JobValidation[]> {
    const url = this.constructPath('/', options);
    const { jobValidations } = await this.common.getJSON(url);
    return jobValidations.map(this.deserialize);
  }
}
